import api from '@/services/api'
import { FeatureFlagsResponse } from './types'

const getFeatureFlags = async (): Promise<string[]> => {
  try {
    const response = await api.get<FeatureFlagsResponse>(`/general/feature-flags`)
    return response.data.features
  } catch (error) {
    console.error('Failed to fetch feature flags:', error)
    return []
  }
}

export default {
  getFeatureFlags
}
